import { createService } from './factory';

const BASE_URL = '/project-templates';

// Create base service using the factory
const baseService = createService('ProjectTemplate', BASE_URL);

class ProjectTemplateService {
  constructor() {
    this.api = baseService;
  }

  /**
   * Get all project templates with pagination and filtering
   */
  async getAllTemplates(options = {}) {
    return this.api.getAll(options);
  }

  /**
   * Get template by ID
   */
  async getTemplateById(id) {
    return this.api.getById(id);
  }

  /**
   * Create new template
   */
  async createTemplate(templateData) {
    return this.api.create(templateData);
  }

  /**
   * Update template
   */
  async updateTemplate(id, templateData) {
    return this.api.update(id, templateData);
  }

  /**
   * Delete template
   */
  async deleteTemplate(id) {
    return this.api.delete(id);
  }

  /**
   * Duplicate template
   */
  async duplicateTemplate(id, newName) {
    return this.api.custom(`${BASE_URL}/${id}/duplicate`, 'POST', { name: newName });
  }

  /**
   * Create project from template
   */
  async createProjectFromTemplate(templateId, projectData) {
    return this.api.custom(`${BASE_URL}/${templateId}/create-project`, 'POST', projectData);
  }

  /**
   * Create template from existing project
   */
  async createTemplateFromProject(projectId, templateData) {
    return this.api.custom(`${BASE_URL}/from-project/${projectId}`, 'POST', templateData);
  }

  /**
   * Duplicate existing project
   */
  async duplicateProject(projectId, projectData) {
    return this.api.custom(`${BASE_URL}/duplicate-project/${projectId}`, 'POST', projectData);
  }

  /**
   * Search templates
   */
  async searchTemplates(searchTerm, options = {}) {
    const params = { q: searchTerm, ...options };
    return this.api.custom(`${BASE_URL}/search`, 'GET', null, params);
  }

  /**
   * Get template statistics
   */
  async getTemplateStats() {
    return this.api.custom(`${BASE_URL}/stats`, 'GET');
  }

  /**
   * Create default templates
   */
  async createDefaultTemplates() {
    return this.api.custom(`${BASE_URL}/default`, 'POST');
  }
}

export default new ProjectTemplateService();